var map = {
	"./bg-BG.json": [
		8637,
		8637
	],
	"./de-DE.json": [
		65679,
		5679
	],
	"./en-US.json": [
		57235,
		7235
	],
	"./es-ES.json": [
		15465,
		5465
	],
	"./fr-FR.json": [
		12545,
		2545
	],
	"./it-IT.json": [
		10698,
		698
	],
	"./nl-NL.json": [
		62961,
		2961
	],
	"./package.json": [
		98374,
		8374
	],
	"./pt-BR.json": [
		51679,
		1679
	],
	"./sv-SE.json": [
		8397,
		8397
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 67761;
module.exports = webpackAsyncContext;